/*
 * Copyright (c) 2022 SARL SIGMA POLYNESIA
 */

import { FormattedMessage } from 'react-intl'
import { Table } from '@mantine/core'
import NoData from '../../../../client/js/components/NoData'
import SelectionToggle from '../../../../client/js/components/selection/SelectionToggle'
import ProspectingListItem from './ProspectingListItem'
import { getProspectingLinkTemplate } from '../../lib/links/prospectingLinks'

export type ProspectingListProps = {
  items: Prospecting[],
  itemLink?: string
}

function ProspectingList (props: ProspectingListProps) {
  const {
    items,
    itemLink = getProspectingLinkTemplate()
  } = props
  return (
    <Table highlightOnHover>
      <Table.Thead>
        <Table.Tr>
          <Table.Th w={50}>
            <SelectionToggle />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="status"
              defaultMessage="État"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="identifier"
              defaultMessage="Identifiant"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="customer"
              defaultMessage="Client"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="type"
              defaultMessage="Type"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="transaction"
              defaultMessage="Transaction"
            />
          </Table.Th>
          <Table.Th ta="end">
            <FormattedMessage
              id="budget"
              defaultMessage="Budget"
            />
          </Table.Th>
          <Table.Th>
            <FormattedMessage
              id="cities"
              defaultMessage="Villes"
            />
          </Table.Th>
          <Table.Th w={150}>
            <FormattedMessage
              id="furnishing"
              defaultMessage="Ameublement"
            />
          </Table.Th>
          <Table.Th w={150}>
            <FormattedMessage
              id="equipment"
              defaultMessage="Équipement"
            />
          </Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {items.length > 0
          ? items.map((item) => (
            <ProspectingListItem
              key={item.id}
              item={item}
              itemLink={itemLink}
            />
          ))
          : <Table.Tr>
            <Table.Td colSpan={10}>
              <NoData />
            </Table.Td>
          </Table.Tr>
        }
      </Table.Tbody>
    </Table>
  )
}

export default ProspectingList
